import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  icon: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  content: {
    width: 500,
    mt: -2,
  },
  text: {
    color: "rgba(0, 0, 0, 0.87)",
    textAlign: "center",
  },
  delete: {
    ml: 2,
    mr: 1,
  },
};

export default function DeleteRoleAlertDialog({
  showDialog,
  closeDialog,
  onDelete,
}: any) {
  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete Role?</DialogTitle>
      <IconButton aria-label="close" onClick={closeDialog} sx={styles.icon}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.content}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={styles.text}>
            Are you sure you want to delete this role?
          </Typography>
          <Typography sx={styles.text}>This action can’t be undone.</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={closeDialog}>
          Cancel
        </Button>
        <Button sx={styles.delete} onClick={onDelete} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
